<article>
	<header>
		<cache-date></cache-date>
	</header>
	
	<section>
		<period></period>
	</section>
	
	<section>
		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
	</section>
	
	<section>
		<chart [data]="disableRecurrentChart.data" [options]="disableRecurrentChart.options"></chart>
	</section>
	
	<section>
		<chart [data]="disableRecurrentChart2.data" [options]="disableRecurrentChart2.options"></chart>
	</section>
	
	<section>
		<chart [data]="disableRecurrentDetailChart.data" [options]="disableRecurrentDetailChart.options"></chart>
	</section>
</article>
  

